import settings from '/@/core/settings';
import colors from '../../theme-provider/colors';

const SVGPoint = ({ selected = false, name, area }: { selected?: boolean; name?: string; area?: number }) => {
    const currentTheme = (settings as any).app?.theme || 'cultivio';
    const base = colors.themes[currentTheme as keyof typeof colors.themes]?.mui;
    const themeType = selected ? 'secondary' : 'primary';

    const strokeColor = base?.[themeType]?.[themeType];
    const fillColor = base?.primary?.[selected ? 'itemSelectedBackground' : 'infoBackground'];

    return (
        <svg
            width='26'
            id='map-point'
            height='36'
            viewBox='0 0 26 36'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            style={{ cursor: 'pointer' }}
            role='img'
            aria-label={name ? `Map point for ${name}` : 'Map point'}
        >
            <title>{name || 'Map point'}</title>
            <path
                d='M12.667 0.5C19.3931 0.500087 24.834 5.9409 24.834 12.667C24.8339 14.9556 24.0733 17.4783 22.9668 19.9482C21.8574 22.4246 20.3827 24.8853 18.915 27.0605C17.4464 29.2373 15.9781 31.1376 14.8779 32.4932C14.3276 33.1712 13.8687 33.7144 13.5469 34.0879C13.386 34.2746 13.2596 34.4194 13.1729 34.5176C13.1296 34.5665 13.0959 34.6035 13.0732 34.6289C13.0619 34.6416 13.0528 34.6516 13.0469 34.6582C13.044 34.6614 13.0416 34.6643 13.04 34.666L13.0391 34.668H13.0381L12.667 35.0791L12.2959 34.668H12.2949C12.2945 34.6675 12.2937 34.6668 12.293 34.666C12.2914 34.6643 12.2891 34.6615 12.2861 34.6582C12.2802 34.6516 12.272 34.6416 12.2607 34.6289C12.2381 34.6036 12.2044 34.5665 12.1611 34.5176C12.0745 34.4194 11.9479 34.2745 11.7871 34.0879C11.4653 33.7144 11.0064 33.1712 10.4561 32.4932C9.35586 31.1376 7.88768 29.2374 6.41895 27.0605C4.95132 24.8853 3.47664 22.4246 2.36719 19.9482C1.26066 17.4783 0.500081 14.9556 0.5 12.667C0.5 5.94085 5.94085 0.5 12.667 0.5ZM12.667 9C10.6431 9 9 10.6431 9 12.667C9.0002 14.6907 10.6433 16.333 12.667 16.333C14.6907 16.3329 16.3338 14.6906 16.334 12.667C16.334 10.6432 14.6908 9.00009 12.667 9Z'
                fill={fillColor}
                stroke={strokeColor}
            />
        </svg>
    );
};

export default SVGPoint;
